
































import { Component, Vue, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import BaseVue from "@/core/BaseVue";
import { Route } from "vue-router";
import Language from "@/models/language/language.model";
import LanguageGroup from '@/models/language/languageGroup/languageGroup.model';
import IndicatorGroup from "@/models/indicator/indicatorGroup.model";
import IndicatorType from "@/models/indicator/indicatorType.model";
@Component
export default class LanguageLabelBase extends BaseVue {

  protected indicatorTypeId: number | null = null;
  protected indicatorGroupId: number | null = null;
  protected loading = false;
  protected repositoryIndicatorType!: BaseRepository<IndicatorType>;
  protected repositoryIndicatorGroup!: BaseRepository<IndicatorGroup>;

  protected modelIndicatorType: IndicatorType | any = null;
  protected modelInicatorGroup: IndicatorGroup | any = null;

  created() {
    this.indicatorTypeId = Number.parseInt(this.$route.params.indicatorTypeId);
    this.indicatorGroupId = Number.parseInt(
      this.$route.params.indicatorGroupId
    );

    if (
      this.hasParent &&
      this.modelIndicatorType == null &&
      this.modelInicatorGroup == null
    ) {
      this.repositoryIndicatorGroup = new BaseRepository<IndicatorGroup>(
        "IndicatorGroups"
      );
      this.repositoryIndicatorType = new BaseRepository<IndicatorType>(
        "IndicatorTypes"
      );
      this.getData();
    }
  }
  get nameIndicatorGroup() {
    return this.hasParent && this.modelInicatorGroup
      ? this.modelInicatorGroup.name
      : "---";
  }
  get nameIndicatorType() {
    return this.hasParent && this.modelIndicatorType
      ? this.modelIndicatorType.name
      : "---";
  }
  gotToListIndicatorGroup() {
    this.$router.push("/indicatorGroup");
  }
  gotToListInidcatorType() {
    this.$router.push(`/indicatorGroup/${this.indicatorGroupId}/indicatorType`);
  }
  protected async getData() {
    debugger
    try {
      
      if (this.indicatorTypeId && this.indicatorGroupId)
        this.modelInicatorGroup = await this.repositoryIndicatorGroup.getById(
          this.indicatorGroupId
        );
      this.modelIndicatorType = await this.repositoryIndicatorType.getById(
        this.indicatorTypeId as any
      );
    } catch (errors) {
      this.operationFailedErrors(errors);
    } finally {
     
    }
  }
  get hasParent() {
    return (
      !!this.$route.params.indicatorGroupId &&
      !!this.$route.params.indicatorTypeId
    );
  }
}
